import { IDisposable } from "Core/Interfaces";
import { NotificationService } from "Service/NotificationService";
import { Navigation } from "./Navigation";
import { AppContext } from "./AppContext";

/**
 * @hidden
 */
export class NotificationControl implements IDisposable {
    private static buttonTemplate = require("./Templates/NotificationControl.html").default;

    constructor(private notificationService: NotificationService) {}

    private notificationModel: kendo.data.ObservableObject;

    initialize(jQueryElement: JQuery<HTMLElement>) {
        this.notificationService.init((n) => {
            this.notificationModel.set("count", n);
        });

        this.notificationModel = kendo.observable({
            ...AppContext.current.appViewModel,
            ...{
                count: 0,
            },
        });

        let elem = $(NotificationControl.buttonTemplate);
        jQueryElement.append(elem);
        kendo.bind(elem, this.notificationModel);

        elem.on("click", () => Navigation.navigate("~/DMS/int_Notification"));
    }

    dispose(): void {}
}
